/*
  reports state
*/
export default {
  // List loading state (drives the Templates/Scheduled loaders)
  loading: false,
  list: [],
  dictList: {}
}
